import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Tab } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/concierge.js';
import axios from 'axios';


function ConciergeService() {
    const [allServices, setAllServices] = useState([]);

    useEffect(() => {
        document.title = 'Concierge Service | REAL FM';
        const courseButton = document.querySelectorAll(".course-button");
        courseButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "course-content show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "course-content";
                    content.style.maxHeight = "0";
                }
            });
        });
    });

    useEffect(() => {
        const fetchAllServices = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/services/find-all`).then((res) => {
                setAllServices(res.data);
            }).catch(error => {
                console.error(error);
            });
        };
        fetchAllServices();
    },[]);

    return (
        <div className="main-wrapper course-details-page" >

            {/* Header 2 */}
            <HeaderTwo />

            {/* Breadcroumb */}
            <BreadcrumbBox title="Concierge Services" />

            <Styles>
                {/* Course Details */}
                <section className="course-details-area">
                <Container className="card custom-card">
                        <Row>
                            <Col lg="12" md="12" sm="12">
                                <div className="course-details-top">
                                
                                    <div className="course-tab-list">
                                        <Tab.Container defaultActiveKey="overview">
                                            
                                            <Tab.Content>
                                                <Tab.Pane eventKey="overview" className="overview-tab">
                                                {
                                                    allServices !== null && allServices.length > 0 ? allServices.map((service, i) => (
                                                        service.serviceType.toUpperCase() === "CONCIERGE" ? 
                                                            <React.Fragment key={i}>
                                                                <div className="course-desc">
                                                                    <p  dangerouslySetInnerHTML={{ __html: service.serviceDesc}}></p>
                                                                </div>
                                                                <div className="course-feature">
                                                                    <Row>
                                                                        
                                                                        {/* <Col lg="6" md="6" sm="12">
                                                                            <img src={process.env.PUBLIC_URL + `/assets/images/concierge-1.jpg`} alt="" className="img-fluid" />
                                                                        </Col>  */}
                                                                        <Col lg="6" md="6" sm="12">
                                                                            <img src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${service.serviceImg.substring(service.serviceImg.indexOf("/uploads"))}`} alt={service.serviceName} className="img-fluid" />
                                                                        </Col>                                                       
                                                                    </Row>
                                                                    
                                                                </div>
                                                                <div className="course-learn">
                                                                    <h5>Our Concierge Services include: </h5>
                                                                    {
                                                                        service.servicesIncl !== null && service.servicesIncl.length > 0 ? service.servicesIncl.map((serviceIncl, i) => (
                                                                            <React.Fragment key={i}>
                                                                                <Row>
                                                                                    <Col>
                                                                                    <ul className="list-unstyled" >
                                                                                        <li><i className="fa fa-check"></i> {serviceIncl}</li>                                                   
                                                                                    </ul>

                                                                                    </Col>                                                                   
                                                                                </Row>  
                                                                            </React.Fragment>
                                                                        )) : "No included service found"
                                                                    }
                                                                        
                                                                </div>
                                                  
                                                            </React.Fragment> :  "")) : "No services found"
                                                }
                                                    
                                                    
                                                </Tab.Pane>
                                                
                                            </Tab.Content>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </Col>
                            
                        </Row>
                    </Container>
                </section>
            </Styles>

            {/* Footer 2 */}
            <FooterTwo />

        </div>
    )
}

export default ConciergeService